module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("DLP安装指南 for windows")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic15.png"),
      "width": "850px",
      "height": "280px"
    }
  }), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic16.png"),
      "width": "850px",
      "height": "330px"
    }
  }), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("二、绑定用户名")]), _vm._v(" "), _vm._m(3), _vm._v("\n  已安装赛门铁克杀毒软件的电脑双击下载好的安装包若弹出如下弹框，"), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("选择“允许使用此文件”")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic1.jpg"),
      "width": "600px",
      "height": "600px"
    }
  }), _c('br'), _vm._v("\n  点击“确定”"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic2.jpg"),
      "width": "600px",
      "height": "600px"
    }
  }), _c('br'), _vm._v("\n  双击下载后的文件出现解压信息如下图，选择需要解压到的文件夹点击“解压”："), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic3.png"),
      "width": "600px",
      "height": "400px"
    }
  }), _c('br'), _c('br'), _vm._v("\n  解压终端安装包后文件包括："), _c('br'), _vm._v("\n 1) 终端安装程序 MT-DLP.exe     用于进行终端完整安装"), _c('br'), _vm._v("\n 2）msec.dat 文件"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic4.png"),
      "width": "300px",
      "height": "150px"
    }
  }), _c('br'), _c('br'), _vm._v("\n 终端安装步骤如下："), _c('br'), _vm._v("\n 1、 右键— MT-DLP.exe，"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("以管理员身份安装")]), _vm._v("，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic5.jpg"),
      "width": "350px",
      "height": "120px"
    }
  }), _c('br'), _c('br'), _vm._v("\n 进入安装界面"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic6.png"),
      "width": "600px",
      "height": "450px"
    }
  }), _c('br'), _vm._v("\n 2、点击“浏览”按钮，选择安装目录。默认安装目录为：C:\\Program Files\\CirrusGate\\dlp3.0"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic7.png"),
      "width": "600px",
      "height": "400px"
    }
  }), _c('br'), _vm._v("\n 3、 点击“下一步”按钮，如果此计算机安装过DLP3.0，卸载后会有残余文件，忽略这些文件。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic8.png"),
      "width": "500px",
      "height": "350px"
    }
  }), _c('br'), _vm._v("\n 4、 点击“是”，进入下一安装界面"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic9.png"),
      "width": "500px",
      "height": "350px"
    }
  }), _c('br'), _vm._v("\n 5、点击“下一步”，进入“准备开始安装”界面。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic10.png"),
      "width": "500px",
      "height": "350px"
    }
  }), _c('br'), _vm._v("\n 6、 点击“安装”按钮，显示安装进度条。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic11.png"),
      "width": "500px",
      "height": "350px"
    }
  }), _c('br'), _vm._v("\n 7、 安装完成后提示界面， 点击“完成”按钮，完成DLP3.0的Windows终端安装。"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic12.png"),
      "width": "500px",
      "height": "350px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "color": "red"
    }
  }, [_vm._v("二、绑定账号")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "red"
    }
  }, [_vm._v("注意 ：部分域内WINDOWS用户会自动绑定，无需以下步骤！！！！！！")]), _c('br'), _vm._v("\n  安装完成后 会跳出如下界面"), _c('br'), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic13.png"),
      "width": "400px",
      "height": "300px"
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }, [_vm._v("安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！"), _c('br'), _vm._v("\n  如果未出现弹窗说明被系统识别mis账号，忽略此步骤（"), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("已安装却仍收到SSO消息提醒 ，解决方法详见")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.kmUrl('https://km.sankuai.com/page/19884626')
      }
    }
  }, [_vm._v("已安装却仍收到SSO消息提醒")]), _vm._v("\n  ）")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic14.png"),
      "width": "500px",
      "height": "400px"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "red"
    }
  }, [_vm._v("有问题可以直接大象6000或者私聊huawei02。")]), _vm._v(" "), _c('br'), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("软件下载地址："), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "title": "https://itportal.sankuai.com/",
      "href": "https://itportal.sankuai.com/",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("https://itportal.sankuai.com/")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(112, 112, 112)"
    }
  }, [_vm._v("一、软件安装")]), _vm._v("DLP主要安装过程包含三部分内容：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(112, 112, 112)"
    }
  }, [_vm._v("一、软件安装")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)"
    }
  }, [_vm._v("一、软件安装")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }, [_vm._v("注意 ："), _c('br'), _vm._v("\n （1）账号为mis账号，请填写正确的mis账号；"), _c('br'), _vm._v("\n （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。"), _c('br'), _vm._v("\n  如：用户名：meituan")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-020c0ccc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataLeakInstallForWin.vue
// module id = 632
// module chunks = 1